module.exports = __webpack_public_path__ + "img/logo.0cd2b854.png";